import styled from 'styled-components'

export const Container = styled.div`
    background: #fff;
    padding: 16px;
    border-radius: 3px;
    display: flex;

    .PowerBarDiv {
        margin-right: 10px;
    }

    .InfoDiv {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: space-between;

        .Status {
            background: #53dbb9;
            border-radius: 4px;
            padding: 3px;
            font-weight: 600;
            font-size: 12px;
            line-height: 16px;
            color: #ffffff;
            text-align: center;
        }

        .Barriers {
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            font-weight: normal;
            font-size: 11px;
            line-height: 16px;
            color: #606a80;

            .Active {
                margin-top: 6px;
                font-weight: normal;
                font-size: 11px;
                line-height: 16px;
                color: #868695;

                .Value {
                    font-weight: 600;
                    font-size: 16px;
                    line-height: 16px;
                    color: ${({color}) => color || '#000'};
                }
            }

            .Degraded {
                padding-top: 3px;
                margin-top: 3px;
                font-weight: normal;
                font-size: 11px;
                line-height: 16px;
                color: #868695;
                border-top: 1px solid #dddee1;

                .Value {
                    font-weight: 600;
                    font-size: 14px;
                    line-height: 16px;
                    color: ${({color}) => color || '#000'};
                }
            }
        }
    }

    .CenterDiv {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .Unity {
            font-weight: bold;
            font-size: 22px;
            line-height: 24px;
            color: #37a3ef;

            .Id {
                font-weight: 600;
                font-size: 12px;
                line-height: 16px;
                color: #364159;
            }
        }

        .Manager {
            font-weight: 600;
            font-size: 12px;
            line-height: 16px;
            color: #364159;

            .Label {
                font-weight: normal;
                font-size: 11px;
                line-height: 16px;
                color: #606a80;
            }
        }
    }
`

export const BarSquareContainer = styled.div`
    width: 12px;
    height: 10px;
    background: ${({ color }) => color || '#c8ccd4'};
    margin-bottom: 2px;

    &:last-child {
        margin-bottom: 0px;
    }
`
